import React from "react";
import "./Button.css";

/**
 * Design-system Button (Savills UDS).
 *
 * @param {"primary"|"outline"|"ghost"|"destructive"} variant
 * @param {"sm"|"md"} size  sm = 34px (UDS small CTA), md = 44px
 * @param {React.ReactNode} startIcon / endIcon  18px icon slots (inherit currentColor)
 * @param {boolean} fullWidth
 */
const Button = React.forwardRef(function Button(
  {
    variant = "primary",
    size = "md",
    startIcon,
    endIcon,
    fullWidth = false,
    className = "",
    children,
    type = "button",
    ...rest
  },
  ref,
) {
  const classes = [
    "kc-button",
    `kc-button--${variant}`,
    `kc-button--${size}`,
    fullWidth ? "kc-button--full" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button ref={ref} type={type} className={classes} {...rest}>
      {startIcon && <span className="kc-button__icon">{startIcon}</span>}
      {children}
      {endIcon && <span className="kc-button__icon">{endIcon}</span>}
    </button>
  );
});

export default Button;
